import type {ReactAction} from '@netx/core/bootstrap';
import {faCheck} from '@netx/core-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canAddAssetToCart} from '../enablers';
import {CartAssetActionLabel} from '../locales';
import {CART_ASSET_EVENT} from './constants';

/**
 * Add asset to current cart
 * @param params
 * @returns Action
 */
export const cartAssetActionAdd = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-asset-add',
	cb: () => dispatcher.trigger(CART_ASSET_EVENT.ADD_TO_CART, asset.assetId),
	enableTest: canAddAssetToCart,
	icon: faCheck,
	get label() {
		return CartAssetActionLabel.ADD_TO_CART;
	},
	...params,
});

export default cartAssetActionAdd;
